const Regions = {
    0: "johto",
    1: "kanto",
    2: "hoenn",
    3: "sinnoh",
    4: "unova",
    5: "kalos",
    6: "alola"
}

export default Regions;